import React from 'react'
import Header_nav from './Header_nav'
import Sidebar from './Sidebar'
import { useLocation } from 'react-router-dom';

const Header = () => {
    const [isPinned, setIsPinned] = React.useState(true);
    const [isToogle, setIsToogle] = React.useState(false);
    
    const handlePinToggle = () => {
      setIsPinned(prev => !prev);
    };
    
    const handleToggle = () => {
      setIsToogle(prev => !prev);
    };
    
    React.useEffect(() => {
        const pageWrapper = document.querySelector(".page-wrapper");
        if (pageWrapper) {
          pageWrapper.classList.toggle("pinned", isPinned);
          pageWrapper.classList.toggle("toggled", isToogle); // ✅ updated here
        }
      }, [isPinned, isToogle]);
  return (
    <div >
     
	{/* <!-- Page wrapper start --> */}
    <div class="page-wrapper">

    {/* <!-- Main container start --> */}
    <div class="main-container">

        {/* <!-- Sidebar wrapper start --> */}
        <nav id="sidebar-wrapper " class="sidebar-wrapper">

            {/* <!-- App brand starts --> */}
            <div class="app-brand px-3 py-2 d-flex align-items-center">
                <a href="/">
                    <div class="d-flex justify-content-between">
                        <div><img src="../../../assets/img/logo.png" class="logo" alt="Skyship" /></div>
                        <div class="logo_text"><h2>Skyship</h2></div>
                    </div>
                </a>
            </div>
            {/* <!-- App brand ends --> */}

            {/* <!-- Sidebar menu starts --> */}
            {/* <?php include('sidebar.php'); ?> */}
			<Sidebar/>
            {/* <!-- Sidebar menu ends --> */}

        </nav>
        {/* <!-- Sidebar wrapper end --> */}

        {/* <!-- App container starts --> */}
        <div class="app-container">

            {/* <!-- App header starts --> */}
            {/* <?php include('header_nav.php'); ?> */}
			<Header_nav onPinToggle={handlePinToggle} onToggle={handleToggle}/>
            {/* <!-- App header ends --> */}

            {/* <!-- App body starts --> */}
        
            {/* <!-- App body ends --> */}

        
         

        </div>
        {/* <!-- App container ends --> */}

    </div>
   

</div>
{/* <!-- Page wrapper end --> */}

    </div>

   

  )
}

export default Header
